// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rcti-agreements {
  min-height: 100vh;
  color: var(--text-primary);
  background: var(--bg-primary);
  font-family: var(--font-family-primary);
}
.business-dashboard.rcti-agreements[data-theme="dark"] {
  --text-link: var(--interactive-hover);
}
.rcti-agreements__main {
  margin-left: 256px;
  min-width: 0;
}
.rcti-agreements__content {
  padding: var(--space-6);
  display: grid;
  gap: var(--space-5);
  max-width: 1200px;
  margin-inline: auto;
}
.rcti-agreements .rcti-agreements__content {
  color: var(--text-primary);
  font-family: var(--font-family-primary);
}
.rcti-agreements__content :is(h1, h2, h3, h4):not(.rcti-agreement-badge),
.rcti-agreements__content :is(label, legend, td) {
  color: var(--text-primary);
}
.rcti-agreements__content :is(h1, h2, h3, h4, label, legend) {
  font-family: var(--font-family-primary);
}
.rcti-agreements__content :is(input, textarea)::placeholder {
  color: var(--text-secondary);
  opacity: 1;
}
.rcti-agreements .rcti-agreements__content .rcti-agreements__error {
  color: var(--danger-text);
}
.rcti-agreements .rcti-agreements__content a:not(.rcti-design-primary) {
  color: var(--text-link);
}
.rcti-agreements__content h1 {
  font-size: var(--font-size-h2);
}
.rcti-agreements__content h2 {
  font-size: var(--font-size-h4);
}
.rcti-agreements__content p {
  line-height: 1.6;
}
.rcti-agreement-card {
  padding: var(--space-5);
  border: 1px solid var(--border-default);
  border-radius: var(--radius-md);
  background: var(--surface-primary);
  display: grid;
  gap: var(--space-4);
  min-width: 0;
  overflow-wrap: anywhere;
}
.rcti-agreements__content label {
  display: grid;
  gap: var(--space-2);
  font-size: var(--font-size-body-sm);
}
.rcti-agreements__content input:not([type="checkbox"]),
.rcti-agreements__content select,
.rcti-agreements__content textarea,
.rcti-eligibility select {
  width: 100%;
  padding: var(--space-3);
  color: var(--text-primary);
  background: var(--surface-primary);
  border: 1px solid var(--border-default);
  border-radius: var(--radius-md);
  font: inherit;
  box-sizing: border-box;
}
.rcti-agreements__content button {
  display: inline-flex;
  height: 40px;
  min-height: 40px;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 0 12px;
  background: var(--interactive-default);
  color: var(--on-interactive-primary);
  border: 0;
  border-radius: var(--radius-md, 10px);
  font-family: var(--font-family-primary, "Lexend", sans-serif);
  font-size: 13px;
  font-style: normal;
  font-weight: var(--font-weight-medium, 500);
  line-height: normal;
  letter-spacing: 0;
  cursor: pointer;
}
.rcti-agreements__content button:disabled {
  opacity: 0.5;
  cursor: default;
}
.rcti-agreements :focus-visible,
.rcti-eligibility :focus-visible:not(.quotation-figma-dropdown-trigger) {
  outline: 2px solid var(--focus-ring);
  outline-offset: 2px;
}
.rcti-agreements__actions {
  display: flex;
  flex-wrap: wrap;
  gap: var(--space-3);
  align-items: center;
}
.rcti-agreements .rcti-consent {
  display: flex;
  align-items: flex-start;
  gap: var(--space-3);
}
.rcti-eligibility {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: var(--space-4);
  border: 1px solid var(--border-default);
  border-radius: var(--radius-md);
  padding: var(--space-4);
  min-width: 0;
}
.rcti-eligibility label {
  display: grid;
  gap: var(--space-2);
  font-size: var(--font-size-body-sm);
}
.rcti-eligibility legend {
  font-size: var(--font-size-body-sm);
}
.rcti-agreements__error {
  color: var(--danger-text);
}
.rcti-agreements__status {
  color: var(--text-secondary);
}
.rcti-agreements--public .rcti-agreements__content {
  max-width: 850px;
}
@media (max-width: 1024px) {
  .rcti-agreements__main {
    margin-left: 0;
  }
}
@media (max-width: 600px) {
  .rcti-agreements__content {
    padding: var(--space-4);
  }
}

/* Controls are scoped to page content so navigation and header retain their styles. */
.rcti-agreements__content {
  box-sizing: border-box;
  width: 100%;
  align-content: start;
}
.rcti-agreements__content h1,
.rcti-agreements__content h2,
.rcti-agreements__content p,
.rcti-signature-pad p {
  margin: 0;
}
.rcti-agreements__content h1 {
  font-weight: var(--font-weight-semibold);
  line-height: 1.3;
}
.rcti-agreements__content h2 {
  font-weight: var(--font-weight-medium);
}
.rcti-agreements__content > p {
  max-width: 75ch;
  color: var(--text-secondary);
  font-size: var(--font-size-body-sm);
}
.rcti-agreement-card form,
form.rcti-agreement-card {
  display: grid;
  gap: var(--space-4);
}
.rcti-buyer-summary {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
}
.rcti-buyer-summary p {
  color: var(--text-secondary);
  margin-top: var(--space-2);
}
.rcti-agreements__content a {
  color: var(--text-link);
  font-size: var(--font-size-body-sm);
  text-underline-offset: 3px;
}
.rcti-agreements__content button {
  width: -moz-fit-content;
  width: fit-content;
  max-width: 100%;
}
.rcti-agreements__content button:hover:not(:disabled) {
  background: var(--interactive-hover);
}
.rcti-agreements__content .rcti-button-secondary {
  background: var(--surface-primary);
  color: var(--text-primary);
  border: 1px solid var(--border-default);
}
.rcti-agreements__content .rcti-button-secondary:hover:not(:disabled) {
  background: var(--surface-secondary);
}
.rcti-agreements__content input[readonly] {
  background: var(--surface-secondary);
  color: var(--text-secondary);
}
.rcti-agreements__content
  :is(input:not([type="checkbox"]), select, textarea):disabled {
  background: var(--surface-secondary);
  color: var(--text-disabled);
}
.rcti-agreements__content textarea {
  resize: vertical;
  min-height: 100px;
}
.rcti-agreements__status {
  font-size: var(--font-size-body-sm);
}
.rcti-consent input {
  width: 18px;
  height: 18px;
  flex: 0 0 auto;
  margin-top: 2px;
  accent-color: var(--interactive-default);
}
.rcti-signature-pad {
  min-width: 0;
  margin: 0;
  padding: var(--space-4);
  border: 1px solid var(--border-default);
  border-radius: var(--radius-md);
  display: grid;
  gap: var(--space-3);
}
.rcti-signature-pad legend {
  font-size: var(--font-size-label-md);
}
/* Override the legacy App fieldset border written inline during theme changes. */
.rcti-agreements .rcti-signature-pad {
  border-color: var(--border-default) !important;
}
.rcti-signature-pad p {
  color: var(--text-secondary);
  font-size: var(--font-size-body-sm);
}
.rcti-signature-pad canvas {
  max-width: 720px;
  display: block;
  width: 100%;
  height: auto;
  aspect-ratio: 3 / 1;
  background: var(--neutral-0);
  border: 1px dashed var(--border-strong);
  border-radius: var(--radius-sm);
  touch-action: none;
  cursor: crosshair;
  box-sizing: border-box;
}
.rcti-signature-pad:disabled canvas {
  cursor: default;
  opacity: 0.6;
}
.rcti-saved-signature {
  margin: 0;
  display: grid;
  gap: var(--space-2);
}
.rcti-saved-signature figcaption {
  font-size: var(--font-size-label-md);
  color: var(--text-secondary);
}
.rcti-saved-signature img {
  display: block;
  width: min(100%, 360px);
  max-height: 160px;
  object-fit: contain;
  background: var(--neutral-0);
  border: 1px solid var(--border-default);
  border-radius: var(--radius-sm);
}
.profile-abr-check {
  margin-top: var(--space-3);
  padding: var(--space-2) var(--space-3);
  border: 1px solid var(--border-default);
  border-radius: var(--radius-md);
  background: var(--surface-primary);
  color: var(--text-link);
  font: inherit;
  cursor: pointer;
}
.profile-abr-check:disabled {
  opacity: 0.5;
  cursor: default;
}
.profile-abr-success {
  color: var(--success-text);
  font-size: var(--font-size-body-sm);
}
.profile-abr-error {
  color: var(--danger-text);
  font-size: var(--font-size-body-sm);
}
.profile-eligibility-help {
  margin-top: var(--space-3);
  color: var(--text-secondary);
  font-size: var(--font-size-body-sm);
}
@media (max-width: 600px) {
  .rcti-agreement-card {
    padding: var(--space-4);
  }
  .rcti-agreements__actions > button {
    flex: 1 1 auto;
  }
  .rcti-eligibility {
    grid-template-columns: 1fr;
  }
}
@media print {
  .rcti-agreements--public {
    background: var(--neutral-0);
  }
  .rcti-agreements--public button,
  .rcti-agreements--public form {
    display: none;
  }
  .rcti-agreements--public .rcti-agreement-card {
    border: 0;
  }
}

.rcti-profile-eligibility {
  margin-top: var(--space-6);
  padding: var(--space-5);
  background: var(--surface-primary);
  border: 1px solid var(--border-default);
  border-radius: var(--radius-md);
  color: var(--text-primary);
}
.rcti-profile-eligibility h2 {
  font-family: var(--font-family-primary);
  font-size: var(--font-size-h4);
  margin: 0 0 var(--space-3);
}
.rcti-profile-eligibility form {
  display: grid;
  gap: var(--space-4);
  margin-top: var(--space-4);
}
.rcti-profile-eligibility p {
  margin: 0;
  font-size: var(--font-size-body-sm);
  line-height: 1.6;
}
.rcti-profile-eligibility form > label {
  display: grid;
  gap: var(--space-2);
  max-width: 480px;
  font-size: var(--font-size-label-md);
}
.rcti-profile-eligibility input {
  padding: var(--space-3);
  border: 1px solid var(--border-default);
  border-radius: var(--radius-md);
  background: var(--surface-primary);
  color: var(--text-primary);
  font: inherit;
}
.rcti-profile-eligibility input[readonly] {
  background: var(--surface-secondary);
  color: var(--text-secondary);
}
.rcti-profile-eligibility button {
  width: -moz-fit-content;
  width: fit-content;
  min-height: 44px;
  padding: var(--space-3) var(--space-4);
  border: 1px solid var(--border-default);
  border-radius: var(--radius-md);
  background: var(--interactive-default);
  color: var(--on-interactive-primary);
  font: inherit;
  font-size: var(--font-size-label-md);
  cursor: pointer;
}
.rcti-profile-eligibility button:disabled {
  opacity: 0.5;
  cursor: default;
}
.rcti-profile-eligibility a {
  color: var(--text-link);
  font-size: var(--font-size-body-sm);
}
.rcti-profile-eligibility :focus-visible {
  outline: 2px solid var(--focus-ring);
  outline-offset: 2px;
}

.rcti-agreement-badge {
  display: inline-flex;
  align-items: center;
  padding: var(--space-1) var(--space-3);
  border-radius: var(--radius-full);
  background: var(--surface-tertiary);
  color: var(--text-secondary);
  text-transform: capitalize;
  font-size: var(--font-size-body-sm);
}
.rcti-agreement-badge--active {
  background: var(--success-soft);
  color: var(--success-text);
}
.rcti-agreement-badge--proposed,
.rcti-agreement-badge--pending {
  background: var(--warning-soft);
  color: var(--warning-text);
}
.rcti-agreement-badge--suspended,
.rcti-agreement-badge--ended,
.rcti-agreement-badge--rejected {
  background: var(--danger-soft);
  color: var(--danger-text);
}
.rcti-agreements__content .rcti-button-danger {
  background: var(--danger-soft);
  color: var(--danger-text);
  border: 1px solid var(--danger-default);
}
.rcti-agreements__content .rcti-button-danger:hover:not(:disabled) {
  background: var(--danger-default);
  color: var(--text-inverse);
}

/* The same document structure is used for supplier review and buyer history. */
.rcti-agreement-document {
  min-width: 0;
}
.rcti-agreement-document__header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: var(--space-5);
  padding-bottom: var(--space-5);
  border-bottom: 3px solid var(--interactive-default);
}
.rcti-agreement-document__header h2 {
  margin: var(--space-2) 0 !important;
  font-size: var(--font-size-h3);
  line-height: 1.3;
}
.rcti-agreement-document__header p {
  color: var(--text-secondary);
  font-size: var(--font-size-body-sm);
  max-width: 52ch;
}
.rcti-document-eyebrow {
  color: var(--text-secondary);
  font-size: var(--font-size-caption-md);
  text-transform: uppercase;
  letter-spacing: 1px;
}
.rcti-document-reference {
  color: var(--text-secondary);
  font-family: var(--font-family-mono);
  font-size: var(--font-size-body-sm);
  white-space: nowrap;
}
.rcti-agreement-document__parties {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--space-5);
  padding: var(--space-5) 0;
}
.rcti-agreement-document__parties h3 {
  margin: var(--space-2) 0;
  font-size: var(--font-size-body-md);
  color: var(--text-primary);
}
.rcti-agreement-document__parties p {
  color: var(--text-secondary);
  font-size: var(--font-size-body-sm);
  overflow-wrap: anywhere;
}
.rcti-agreement-document__metadata {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: var(--space-4);
  background: var(--surface-secondary);
  padding: var(--space-4);
  border-radius: var(--radius-md);
  color: var(--text-secondary);
  font-size: var(--font-size-body-sm);
}
.rcti-agreement-document__metadata h2 {
  font-size: var(--font-size-body-sm);
}
.rcti-agreement-document__section {
  margin-top: var(--space-6);
}
.rcti-agreement-document__section > h3 {
  display: flex;
  align-items: center;
  gap: var(--space-3);
  font-size: var(--font-size-body-md);
  color: var(--text-primary);
  margin: 0 0 var(--space-4);
}
.rcti-agreement-document__section > h3 > span {
  color: var(--interactive-default);
  background: var(--interactive-soft);
  border-radius: var(--radius-sm);
  padding: var(--space-2);
  font-size: var(--font-size-caption-md);
}
.rcti-agreement-document__section > p {
  white-space: pre-wrap;
  font-size: var(--font-size-body-sm);
  line-height: 1.9;
}
.rcti-agreement-document__signatures {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: var(--space-4);
}
.rcti-agreement-document__signatures > div {
  border: 1px solid var(--border-subtle);
  border-radius: var(--radius-md);
  padding: var(--space-4);
  min-width: 0;
}
.rcti-agreement-document__signatures h4 {
  margin: 0 0 var(--space-3);
  font-size: var(--font-size-body-sm);
  font-weight: var(--font-weight-medium);
}
.rcti-agreement-document__signatures p {
  color: var(--text-secondary);
  font-size: var(--font-size-caption-md);
}
.rcti-signature-pending {
  display: grid;
  align-content: center;
  min-height: 100px;
  border-bottom: 1px solid var(--border-subtle);
  margin-bottom: var(--space-3) !important;
}
.rcti-agreement-document__footer {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: var(--space-3);
  margin-top: var(--space-6);
  padding-top: var(--space-4);
  border-top: 1px solid var(--border-subtle);
  font-size: var(--font-size-caption-md);
  color: var(--text-secondary);
}
.rcti-agreement-signing-intro {
  padding-top: var(--space-5);
  border-top: 1px solid var(--border-subtle);
}
.rcti-agreement-signing-intro p {
  margin-top: var(--space-2);
  color: var(--text-secondary);
  font-size: var(--font-size-body-sm);
}
.rcti-agreement-history-title {
  margin-top: var(--space-5);
  font-size: var(--font-size-body-md);
}
@media (max-width: 600px) {
  .rcti-agreement-document__header {
    flex-direction: column;
  }
  .rcti-agreement-document__parties,
  .rcti-agreement-document__signatures {
    grid-template-columns: 1fr;
  }
}
@media print {
  .rcti-agreement-document {
    color: #142624;
    background: #fff;
  }
  .rcti-agreement-document__parties,
  .rcti-agreement-document__signatures {
    grid-template-columns: 1fr 1fr;
  }
  .rcti-agreement-document__signatures {
    page-break-inside: avoid;
    break-inside: avoid;
  }
}
@media print {
  .rcti-agreement-document {
    --surface-primary: #fff;
    --surface-secondary: #f4f7f7;
    --text-primary: #142624;
    --text-secondary: #506360;
    --border-subtle: #dce3e2;
  }
}
.rcti-agreements__loading {
  display: flex;
  flex-direction: column;
  gap: var(--space-5, 20px);
}

.rcti-agreements__loading-controls {
  display: flex;
  align-items: center;
  gap: var(--space-3, 12px);
  flex-wrap: wrap;
}
`, "",{"version":3,"sources":["webpack://./src/layouts/RCTI/agreements.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,0BAA0B;EAC1B,6BAA6B;EAC7B,uCAAuC;AACzC;AACA;EACE,qCAAqC;AACvC;AACA;EACE,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,uBAAuB;EACvB,aAAa;EACb,mBAAmB;EACnB,iBAAiB;EACjB,mBAAmB;AACrB;AACA;EACE,0BAA0B;EAC1B,uCAAuC;AACzC;AACA;;EAEE,0BAA0B;AAC5B;AACA;EACE,uCAAuC;AACzC;AACA;EACE,4BAA4B;EAC5B,UAAU;AACZ;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,uBAAuB;AACzB;AACA;EACE,8BAA8B;AAChC;AACA;EACE,8BAA8B;AAChC;AACA;EACE,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,uCAAuC;EACvC,+BAA+B;EAC/B,kCAAkC;EAClC,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mCAAmC;AACrC;AACA;;;;EAIE,WAAW;EACX,uBAAuB;EACvB,0BAA0B;EAC1B,kCAAkC;EAClC,uCAAuC;EACvC,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;AACxB;AACA;EACE,oBAAoB;EACpB,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,eAAe;EACf,sCAAsC;EACtC,oCAAoC;EACpC,SAAS;EACT,qCAAqC;EACrC,6DAA6D;EAC7D,eAAe;EACf,kBAAkB;EAClB,2CAA2C;EAC3C,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;;EAEE,oCAAoC;EACpC,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,2DAA2D;EAC3D,mBAAmB;EACnB,uCAAuC;EACvC,+BAA+B;EAC/B,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,gBAAgB;AAClB;AACA;EACE;IACE,cAAc;EAChB;AACF;AACA;EACE;IACE,uBAAuB;EACzB;AACF;;AAEA,sFAAsF;AACtF;EACE,sBAAsB;EACtB,WAAW;EACX,oBAAoB;AACtB;AACA;;;;EAIE,SAAS;AACX;AACA;EACE,wCAAwC;EACxC,gBAAgB;AAClB;AACA;EACE,sCAAsC;AACxC;AACA;EACE,eAAe;EACf,4BAA4B;EAC5B,mCAAmC;AACrC;AACA;;EAEE,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;AACrB;AACA;EACE,4BAA4B;EAC5B,0BAA0B;AAC5B;AACA;EACE,uBAAuB;EACvB,mCAAmC;EACnC,0BAA0B;AAC5B;AACA;EACE,uBAAkB;EAAlB,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,kCAAkC;EAClC,0BAA0B;EAC1B,uCAAuC;AACzC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,oCAAoC;EACpC,4BAA4B;AAC9B;AACA;;EAEE,oCAAoC;EACpC,2BAA2B;AAC7B;AACA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,mCAAmC;AACrC;AACA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,eAAe;EACf,wCAAwC;AAC1C;AACA;EACE,YAAY;EACZ,SAAS;EACT,uBAAuB;EACvB,uCAAuC;EACvC,+BAA+B;EAC/B,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,oCAAoC;AACtC;AACA,iFAAiF;AACjF;EACE,8CAA8C;AAChD;AACA;EACE,4BAA4B;EAC5B,mCAAmC;AACrC;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,4BAA4B;EAC5B,uCAAuC;EACvC,+BAA+B;EAC/B,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;AACxB;AACA;EACE,eAAe;EACf,YAAY;AACd;AACA;EACE,SAAS;EACT,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,oCAAoC;EACpC,4BAA4B;AAC9B;AACA;EACE,cAAc;EACd,uBAAuB;EACvB,iBAAiB;EACjB,mBAAmB;EACnB,4BAA4B;EAC5B,uCAAuC;EACvC,+BAA+B;AACjC;AACA;EACE,0BAA0B;EAC1B,sCAAsC;EACtC,uCAAuC;EACvC,+BAA+B;EAC/B,kCAAkC;EAClC,uBAAuB;EACvB,aAAa;EACb,eAAe;AACjB;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,0BAA0B;EAC1B,mCAAmC;AACrC;AACA;EACE,yBAAyB;EACzB,mCAAmC;AACrC;AACA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,mCAAmC;AACrC;AACA;EACE;IACE,uBAAuB;EACzB;EACA;IACE,cAAc;EAChB;EACA;IACE,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,4BAA4B;EAC9B;EACA;;IAEE,aAAa;EACf;EACA;IACE,SAAS;EACX;AACF;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,kCAAkC;EAClC,uCAAuC;EACvC,+BAA+B;EAC/B,0BAA0B;AAC5B;AACA;EACE,uCAAuC;EACvC,8BAA8B;EAC9B,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;AAC5B;AACA;EACE,SAAS;EACT,mCAAmC;EACnC,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,gBAAgB;EAChB,oCAAoC;AACtC;AACA;EACE,uBAAuB;EACvB,uCAAuC;EACvC,+BAA+B;EAC/B,kCAAkC;EAClC,0BAA0B;EAC1B,aAAa;AACf;AACA;EACE,oCAAoC;EACpC,4BAA4B;AAC9B;AACA;EACE,uBAAkB;EAAlB,kBAAkB;EAClB,gBAAgB;EAChB,sCAAsC;EACtC,uCAAuC;EACvC,+BAA+B;EAC/B,sCAAsC;EACtC,oCAAoC;EACpC,aAAa;EACb,oCAAoC;EACpC,eAAe;AACjB;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,uBAAuB;EACvB,mCAAmC;AACrC;AACA;EACE,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,sCAAsC;EACtC,iCAAiC;EACjC,mCAAmC;EACnC,4BAA4B;EAC5B,0BAA0B;EAC1B,mCAAmC;AACrC;AACA;EACE,+BAA+B;EAC/B,0BAA0B;AAC5B;AACA;;EAEE,+BAA+B;EAC/B,0BAA0B;AAC5B;AACA;;;EAGE,8BAA8B;EAC9B,yBAAyB;AAC3B;AACA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,uCAAuC;AACzC;AACA;EACE,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA,+EAA+E;AAC/E;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,mBAAmB;EACnB,8BAA8B;EAC9B,mDAAmD;AACrD;AACA;EACE,mCAAmC;EACnC,8BAA8B;EAC9B,gBAAgB;AAClB;AACA;EACE,4BAA4B;EAC5B,mCAAmC;EACnC,eAAe;AACjB;AACA;EACE,4BAA4B;EAC5B,sCAAsC;EACtC,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,4BAA4B;EAC5B,oCAAoC;EACpC,mCAAmC;EACnC,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,mBAAmB;EACnB,yBAAyB;AAC3B;AACA;EACE,wBAAwB;EACxB,mCAAmC;EACnC,0BAA0B;AAC5B;AACA;EACE,4BAA4B;EAC5B,mCAAmC;EACnC,uBAAuB;AACzB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,oCAAoC;EACpC,uBAAuB;EACvB,+BAA+B;EAC/B,4BAA4B;EAC5B,mCAAmC;AACrC;AACA;EACE,mCAAmC;AACrC;AACA;EACE,0BAA0B;AAC5B;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,mCAAmC;EACnC,0BAA0B;EAC1B,0BAA0B;AAC5B;AACA;EACE,iCAAiC;EACjC,mCAAmC;EACnC,+BAA+B;EAC/B,uBAAuB;EACvB,sCAAsC;AACxC;AACA;EACE,qBAAqB;EACrB,mCAAmC;EACnC,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,gDAAgD;EAChD,mBAAmB;AACrB;AACA;EACE,sCAAsC;EACtC,+BAA+B;EAC/B,uBAAuB;EACvB,YAAY;AACd;AACA;EACE,0BAA0B;EAC1B,mCAAmC;EACnC,sCAAsC;AACxC;AACA;EACE,4BAA4B;EAC5B,sCAAsC;AACxC;AACA;EACE,aAAa;EACb,qBAAqB;EACrB,iBAAiB;EACjB,6CAA6C;EAC7C,wCAAwC;AAC1C;AACA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,mBAAmB;EACnB,0BAA0B;EAC1B,2BAA2B;EAC3B,0CAA0C;EAC1C,sCAAsC;EACtC,4BAA4B;AAC9B;AACA;EACE,2BAA2B;EAC3B,0CAA0C;AAC5C;AACA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,mCAAmC;AACrC;AACA;EACE,0BAA0B;EAC1B,mCAAmC;AACrC;AACA;EACE;IACE,sBAAsB;EACxB;EACA;;IAEE,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,cAAc;IACd,gBAAgB;EAClB;EACA;;IAEE,8BAA8B;EAChC;EACA;IACE,wBAAmB;IAAnB,mBAAmB;EACrB;AACF;AACA;EACE;IACE,uBAAuB;IACvB,4BAA4B;IAC5B,uBAAuB;IACvB,yBAAyB;IACzB,wBAAwB;EAC1B;AACF;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,eAAe;AACjB","sourcesContent":[".rcti-agreements {\n  min-height: 100vh;\n  color: var(--text-primary);\n  background: var(--bg-primary);\n  font-family: var(--font-family-primary);\n}\n.business-dashboard.rcti-agreements[data-theme=\"dark\"] {\n  --text-link: var(--interactive-hover);\n}\n.rcti-agreements__main {\n  margin-left: 256px;\n  min-width: 0;\n}\n.rcti-agreements__content {\n  padding: var(--space-6);\n  display: grid;\n  gap: var(--space-5);\n  max-width: 1200px;\n  margin-inline: auto;\n}\n.rcti-agreements .rcti-agreements__content {\n  color: var(--text-primary);\n  font-family: var(--font-family-primary);\n}\n.rcti-agreements__content :is(h1, h2, h3, h4):not(.rcti-agreement-badge),\n.rcti-agreements__content :is(label, legend, td) {\n  color: var(--text-primary);\n}\n.rcti-agreements__content :is(h1, h2, h3, h4, label, legend) {\n  font-family: var(--font-family-primary);\n}\n.rcti-agreements__content :is(input, textarea)::placeholder {\n  color: var(--text-secondary);\n  opacity: 1;\n}\n.rcti-agreements .rcti-agreements__content .rcti-agreements__error {\n  color: var(--danger-text);\n}\n.rcti-agreements .rcti-agreements__content a:not(.rcti-design-primary) {\n  color: var(--text-link);\n}\n.rcti-agreements__content h1 {\n  font-size: var(--font-size-h2);\n}\n.rcti-agreements__content h2 {\n  font-size: var(--font-size-h4);\n}\n.rcti-agreements__content p {\n  line-height: 1.6;\n}\n.rcti-agreement-card {\n  padding: var(--space-5);\n  border: 1px solid var(--border-default);\n  border-radius: var(--radius-md);\n  background: var(--surface-primary);\n  display: grid;\n  gap: var(--space-4);\n  min-width: 0;\n  overflow-wrap: anywhere;\n}\n.rcti-agreements__content label {\n  display: grid;\n  gap: var(--space-2);\n  font-size: var(--font-size-body-sm);\n}\n.rcti-agreements__content input:not([type=\"checkbox\"]),\n.rcti-agreements__content select,\n.rcti-agreements__content textarea,\n.rcti-eligibility select {\n  width: 100%;\n  padding: var(--space-3);\n  color: var(--text-primary);\n  background: var(--surface-primary);\n  border: 1px solid var(--border-default);\n  border-radius: var(--radius-md);\n  font: inherit;\n  box-sizing: border-box;\n}\n.rcti-agreements__content button {\n  display: inline-flex;\n  height: 40px;\n  min-height: 40px;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 0 12px;\n  background: var(--interactive-default);\n  color: var(--on-interactive-primary);\n  border: 0;\n  border-radius: var(--radius-md, 10px);\n  font-family: var(--font-family-primary, \"Lexend\", sans-serif);\n  font-size: 13px;\n  font-style: normal;\n  font-weight: var(--font-weight-medium, 500);\n  line-height: normal;\n  letter-spacing: 0;\n  cursor: pointer;\n}\n.rcti-agreements__content button:disabled {\n  opacity: 0.5;\n  cursor: default;\n}\n.rcti-agreements :focus-visible,\n.rcti-eligibility :focus-visible:not(.quotation-figma-dropdown-trigger) {\n  outline: 2px solid var(--focus-ring);\n  outline-offset: 2px;\n}\n.rcti-agreements__actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: var(--space-3);\n  align-items: center;\n}\n.rcti-agreements .rcti-consent {\n  display: flex;\n  align-items: flex-start;\n  gap: var(--space-3);\n}\n.rcti-eligibility {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: var(--space-4);\n  border: 1px solid var(--border-default);\n  border-radius: var(--radius-md);\n  padding: var(--space-4);\n  min-width: 0;\n}\n.rcti-eligibility label {\n  display: grid;\n  gap: var(--space-2);\n  font-size: var(--font-size-body-sm);\n}\n.rcti-eligibility legend {\n  font-size: var(--font-size-body-sm);\n}\n.rcti-agreements__error {\n  color: var(--danger-text);\n}\n.rcti-agreements__status {\n  color: var(--text-secondary);\n}\n.rcti-agreements--public .rcti-agreements__content {\n  max-width: 850px;\n}\n@media (max-width: 1024px) {\n  .rcti-agreements__main {\n    margin-left: 0;\n  }\n}\n@media (max-width: 600px) {\n  .rcti-agreements__content {\n    padding: var(--space-4);\n  }\n}\n\n/* Controls are scoped to page content so navigation and header retain their styles. */\n.rcti-agreements__content {\n  box-sizing: border-box;\n  width: 100%;\n  align-content: start;\n}\n.rcti-agreements__content h1,\n.rcti-agreements__content h2,\n.rcti-agreements__content p,\n.rcti-signature-pad p {\n  margin: 0;\n}\n.rcti-agreements__content h1 {\n  font-weight: var(--font-weight-semibold);\n  line-height: 1.3;\n}\n.rcti-agreements__content h2 {\n  font-weight: var(--font-weight-medium);\n}\n.rcti-agreements__content > p {\n  max-width: 75ch;\n  color: var(--text-secondary);\n  font-size: var(--font-size-body-sm);\n}\n.rcti-agreement-card form,\nform.rcti-agreement-card {\n  display: grid;\n  gap: var(--space-4);\n}\n.rcti-buyer-summary {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  align-items: center;\n}\n.rcti-buyer-summary p {\n  color: var(--text-secondary);\n  margin-top: var(--space-2);\n}\n.rcti-agreements__content a {\n  color: var(--text-link);\n  font-size: var(--font-size-body-sm);\n  text-underline-offset: 3px;\n}\n.rcti-agreements__content button {\n  width: fit-content;\n  max-width: 100%;\n}\n.rcti-agreements__content button:hover:not(:disabled) {\n  background: var(--interactive-hover);\n}\n.rcti-agreements__content .rcti-button-secondary {\n  background: var(--surface-primary);\n  color: var(--text-primary);\n  border: 1px solid var(--border-default);\n}\n.rcti-agreements__content .rcti-button-secondary:hover:not(:disabled) {\n  background: var(--surface-secondary);\n}\n.rcti-agreements__content input[readonly] {\n  background: var(--surface-secondary);\n  color: var(--text-secondary);\n}\n.rcti-agreements__content\n  :is(input:not([type=\"checkbox\"]), select, textarea):disabled {\n  background: var(--surface-secondary);\n  color: var(--text-disabled);\n}\n.rcti-agreements__content textarea {\n  resize: vertical;\n  min-height: 100px;\n}\n.rcti-agreements__status {\n  font-size: var(--font-size-body-sm);\n}\n.rcti-consent input {\n  width: 18px;\n  height: 18px;\n  flex: 0 0 auto;\n  margin-top: 2px;\n  accent-color: var(--interactive-default);\n}\n.rcti-signature-pad {\n  min-width: 0;\n  margin: 0;\n  padding: var(--space-4);\n  border: 1px solid var(--border-default);\n  border-radius: var(--radius-md);\n  display: grid;\n  gap: var(--space-3);\n}\n.rcti-signature-pad legend {\n  font-size: var(--font-size-label-md);\n}\n/* Override the legacy App fieldset border written inline during theme changes. */\n.rcti-agreements .rcti-signature-pad {\n  border-color: var(--border-default) !important;\n}\n.rcti-signature-pad p {\n  color: var(--text-secondary);\n  font-size: var(--font-size-body-sm);\n}\n.rcti-signature-pad canvas {\n  max-width: 720px;\n  display: block;\n  width: 100%;\n  height: auto;\n  aspect-ratio: 3 / 1;\n  background: var(--neutral-0);\n  border: 1px dashed var(--border-strong);\n  border-radius: var(--radius-sm);\n  touch-action: none;\n  cursor: crosshair;\n  box-sizing: border-box;\n}\n.rcti-signature-pad:disabled canvas {\n  cursor: default;\n  opacity: 0.6;\n}\n.rcti-saved-signature {\n  margin: 0;\n  display: grid;\n  gap: var(--space-2);\n}\n.rcti-saved-signature figcaption {\n  font-size: var(--font-size-label-md);\n  color: var(--text-secondary);\n}\n.rcti-saved-signature img {\n  display: block;\n  width: min(100%, 360px);\n  max-height: 160px;\n  object-fit: contain;\n  background: var(--neutral-0);\n  border: 1px solid var(--border-default);\n  border-radius: var(--radius-sm);\n}\n.profile-abr-check {\n  margin-top: var(--space-3);\n  padding: var(--space-2) var(--space-3);\n  border: 1px solid var(--border-default);\n  border-radius: var(--radius-md);\n  background: var(--surface-primary);\n  color: var(--text-link);\n  font: inherit;\n  cursor: pointer;\n}\n.profile-abr-check:disabled {\n  opacity: 0.5;\n  cursor: default;\n}\n.profile-abr-success {\n  color: var(--success-text);\n  font-size: var(--font-size-body-sm);\n}\n.profile-abr-error {\n  color: var(--danger-text);\n  font-size: var(--font-size-body-sm);\n}\n.profile-eligibility-help {\n  margin-top: var(--space-3);\n  color: var(--text-secondary);\n  font-size: var(--font-size-body-sm);\n}\n@media (max-width: 600px) {\n  .rcti-agreement-card {\n    padding: var(--space-4);\n  }\n  .rcti-agreements__actions > button {\n    flex: 1 1 auto;\n  }\n  .rcti-eligibility {\n    grid-template-columns: 1fr;\n  }\n}\n@media print {\n  .rcti-agreements--public {\n    background: var(--neutral-0);\n  }\n  .rcti-agreements--public button,\n  .rcti-agreements--public form {\n    display: none;\n  }\n  .rcti-agreements--public .rcti-agreement-card {\n    border: 0;\n  }\n}\n\n.rcti-profile-eligibility {\n  margin-top: var(--space-6);\n  padding: var(--space-5);\n  background: var(--surface-primary);\n  border: 1px solid var(--border-default);\n  border-radius: var(--radius-md);\n  color: var(--text-primary);\n}\n.rcti-profile-eligibility h2 {\n  font-family: var(--font-family-primary);\n  font-size: var(--font-size-h4);\n  margin: 0 0 var(--space-3);\n}\n.rcti-profile-eligibility form {\n  display: grid;\n  gap: var(--space-4);\n  margin-top: var(--space-4);\n}\n.rcti-profile-eligibility p {\n  margin: 0;\n  font-size: var(--font-size-body-sm);\n  line-height: 1.6;\n}\n.rcti-profile-eligibility form > label {\n  display: grid;\n  gap: var(--space-2);\n  max-width: 480px;\n  font-size: var(--font-size-label-md);\n}\n.rcti-profile-eligibility input {\n  padding: var(--space-3);\n  border: 1px solid var(--border-default);\n  border-radius: var(--radius-md);\n  background: var(--surface-primary);\n  color: var(--text-primary);\n  font: inherit;\n}\n.rcti-profile-eligibility input[readonly] {\n  background: var(--surface-secondary);\n  color: var(--text-secondary);\n}\n.rcti-profile-eligibility button {\n  width: fit-content;\n  min-height: 44px;\n  padding: var(--space-3) var(--space-4);\n  border: 1px solid var(--border-default);\n  border-radius: var(--radius-md);\n  background: var(--interactive-default);\n  color: var(--on-interactive-primary);\n  font: inherit;\n  font-size: var(--font-size-label-md);\n  cursor: pointer;\n}\n.rcti-profile-eligibility button:disabled {\n  opacity: 0.5;\n  cursor: default;\n}\n.rcti-profile-eligibility a {\n  color: var(--text-link);\n  font-size: var(--font-size-body-sm);\n}\n.rcti-profile-eligibility :focus-visible {\n  outline: 2px solid var(--focus-ring);\n  outline-offset: 2px;\n}\n\n.rcti-agreement-badge {\n  display: inline-flex;\n  align-items: center;\n  padding: var(--space-1) var(--space-3);\n  border-radius: var(--radius-full);\n  background: var(--surface-tertiary);\n  color: var(--text-secondary);\n  text-transform: capitalize;\n  font-size: var(--font-size-body-sm);\n}\n.rcti-agreement-badge--active {\n  background: var(--success-soft);\n  color: var(--success-text);\n}\n.rcti-agreement-badge--proposed,\n.rcti-agreement-badge--pending {\n  background: var(--warning-soft);\n  color: var(--warning-text);\n}\n.rcti-agreement-badge--suspended,\n.rcti-agreement-badge--ended,\n.rcti-agreement-badge--rejected {\n  background: var(--danger-soft);\n  color: var(--danger-text);\n}\n.rcti-agreements__content .rcti-button-danger {\n  background: var(--danger-soft);\n  color: var(--danger-text);\n  border: 1px solid var(--danger-default);\n}\n.rcti-agreements__content .rcti-button-danger:hover:not(:disabled) {\n  background: var(--danger-default);\n  color: var(--text-inverse);\n}\n\n/* The same document structure is used for supplier review and buyer history. */\n.rcti-agreement-document {\n  min-width: 0;\n}\n.rcti-agreement-document__header {\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: var(--space-5);\n  padding-bottom: var(--space-5);\n  border-bottom: 3px solid var(--interactive-default);\n}\n.rcti-agreement-document__header h2 {\n  margin: var(--space-2) 0 !important;\n  font-size: var(--font-size-h3);\n  line-height: 1.3;\n}\n.rcti-agreement-document__header p {\n  color: var(--text-secondary);\n  font-size: var(--font-size-body-sm);\n  max-width: 52ch;\n}\n.rcti-document-eyebrow {\n  color: var(--text-secondary);\n  font-size: var(--font-size-caption-md);\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n.rcti-document-reference {\n  color: var(--text-secondary);\n  font-family: var(--font-family-mono);\n  font-size: var(--font-size-body-sm);\n  white-space: nowrap;\n}\n.rcti-agreement-document__parties {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: var(--space-5);\n  padding: var(--space-5) 0;\n}\n.rcti-agreement-document__parties h3 {\n  margin: var(--space-2) 0;\n  font-size: var(--font-size-body-md);\n  color: var(--text-primary);\n}\n.rcti-agreement-document__parties p {\n  color: var(--text-secondary);\n  font-size: var(--font-size-body-sm);\n  overflow-wrap: anywhere;\n}\n.rcti-agreement-document__metadata {\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: var(--space-4);\n  background: var(--surface-secondary);\n  padding: var(--space-4);\n  border-radius: var(--radius-md);\n  color: var(--text-secondary);\n  font-size: var(--font-size-body-sm);\n}\n.rcti-agreement-document__metadata h2 {\n  font-size: var(--font-size-body-sm);\n}\n.rcti-agreement-document__section {\n  margin-top: var(--space-6);\n}\n.rcti-agreement-document__section > h3 {\n  display: flex;\n  align-items: center;\n  gap: var(--space-3);\n  font-size: var(--font-size-body-md);\n  color: var(--text-primary);\n  margin: 0 0 var(--space-4);\n}\n.rcti-agreement-document__section > h3 > span {\n  color: var(--interactive-default);\n  background: var(--interactive-soft);\n  border-radius: var(--radius-sm);\n  padding: var(--space-2);\n  font-size: var(--font-size-caption-md);\n}\n.rcti-agreement-document__section > p {\n  white-space: pre-wrap;\n  font-size: var(--font-size-body-sm);\n  line-height: 1.9;\n}\n.rcti-agreement-document__signatures {\n  display: grid;\n  grid-template-columns: repeat(2, minmax(0, 1fr));\n  gap: var(--space-4);\n}\n.rcti-agreement-document__signatures > div {\n  border: 1px solid var(--border-subtle);\n  border-radius: var(--radius-md);\n  padding: var(--space-4);\n  min-width: 0;\n}\n.rcti-agreement-document__signatures h4 {\n  margin: 0 0 var(--space-3);\n  font-size: var(--font-size-body-sm);\n  font-weight: var(--font-weight-medium);\n}\n.rcti-agreement-document__signatures p {\n  color: var(--text-secondary);\n  font-size: var(--font-size-caption-md);\n}\n.rcti-signature-pending {\n  display: grid;\n  align-content: center;\n  min-height: 100px;\n  border-bottom: 1px solid var(--border-subtle);\n  margin-bottom: var(--space-3) !important;\n}\n.rcti-agreement-document__footer {\n  display: flex;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: var(--space-3);\n  margin-top: var(--space-6);\n  padding-top: var(--space-4);\n  border-top: 1px solid var(--border-subtle);\n  font-size: var(--font-size-caption-md);\n  color: var(--text-secondary);\n}\n.rcti-agreement-signing-intro {\n  padding-top: var(--space-5);\n  border-top: 1px solid var(--border-subtle);\n}\n.rcti-agreement-signing-intro p {\n  margin-top: var(--space-2);\n  color: var(--text-secondary);\n  font-size: var(--font-size-body-sm);\n}\n.rcti-agreement-history-title {\n  margin-top: var(--space-5);\n  font-size: var(--font-size-body-md);\n}\n@media (max-width: 600px) {\n  .rcti-agreement-document__header {\n    flex-direction: column;\n  }\n  .rcti-agreement-document__parties,\n  .rcti-agreement-document__signatures {\n    grid-template-columns: 1fr;\n  }\n}\n@media print {\n  .rcti-agreement-document {\n    color: #142624;\n    background: #fff;\n  }\n  .rcti-agreement-document__parties,\n  .rcti-agreement-document__signatures {\n    grid-template-columns: 1fr 1fr;\n  }\n  .rcti-agreement-document__signatures {\n    break-inside: avoid;\n  }\n}\n@media print {\n  .rcti-agreement-document {\n    --surface-primary: #fff;\n    --surface-secondary: #f4f7f7;\n    --text-primary: #142624;\n    --text-secondary: #506360;\n    --border-subtle: #dce3e2;\n  }\n}\n.rcti-agreements__loading {\n  display: flex;\n  flex-direction: column;\n  gap: var(--space-5, 20px);\n}\n\n.rcti-agreements__loading-controls {\n  display: flex;\n  align-items: center;\n  gap: var(--space-3, 12px);\n  flex-wrap: wrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
